<ul
  class="eventq-event-outcome-list"
  role="listbox"
  [style.max-height]="listMaxHeight()"
  aria-label="Event outcomes"
>
  @for (group of visibleGroups(); track group.priority) {
    <li class="eventq-event-outcome-list__group" role="presentation">
      @for (item of group.items; track item.id) {
        <button
          type="button"
          class="eventq-event-outcome-list__row"
          role="option"
          [style.--eventq-outcome-row-bg]="rowBackground(group.priority)"
          [attr.aria-selected]="item.id === selectedOutcomeId()"
          [class.eventq-event-outcome-list__row--selected]="item.id === selectedOutcomeId()"
          (click)="onSelect(item.id)"
        >
          {{ item.label }}
        </button>
      }
    </li>
  }
</ul>
